import { computed, Injectable, signal } from '@angular/core';

const SIN_PETICIONES = 0;
const INCREMENTO = 1;

@Injectable({ providedIn: 'root' })
export class LoadingService {
  public readonly estaCargando = computed(() => this.contadorPeticiones() > SIN_PETICIONES || this.cargaManual());

  private readonly contadorPeticiones = signal(SIN_PETICIONES);
  private readonly cargaManual = signal(false);

  public mostrar(): void {
    this.cargaManual.set(true);
  }

  public ocultar(): void {
    this.cargaManual.set(false);
  }

  public iniciarPeticion(): void {
    this.contadorPeticiones.update((c) => c + INCREMENTO);
  }

  public finalizarPeticion(): void {
    this.contadorPeticiones.update((c) => Math.max(SIN_PETICIONES, c - INCREMENTO));
  }
}
